import { handleCredentialResponse } from "~/scripts/utils/google.js";

class SignGoogle extends window.HTMLElement {
  constructor() {
    super();

    window.onload = function () {
      if (window?.google) {
        google.accounts.id.initialize({
          client_id:
            "408201333939-qb2kfaq3djte2hhd9ch6rqk7te5ej9ve.apps.googleusercontent.com",
          callback: handleCredentialResponse,
        });

        const googleBtn = document.getElementById("btn-sign-with-google");

        googleBtn &&
          google.accounts.id.renderButton(googleBtn, {
            theme: "outline",
            size: "large",
            logo_alignment: "left",
            itp_support: false,
            width: 320,
          });
      }
    };
  }
}

window.customElements.define("sign-google", SignGoogle);
